import { createAction, props } from '@ngrx/store';
import { IPatientPortalLayout } from '@care-portals/api-interfaces';

export const loadApp = createAction('[App] Load App');

export const loadAppLayout = createAction('[App] Load App Layout');

export const loadAppLayoutSuccess = createAction(
  '[App] Load App Layout Success',
  props<{ layout: IPatientPortalLayout }>()
);

export const loadAppLayoutFailure = createAction(
  '[App] Load App Layouts Failure',
  props<{ error: any }>()
);

export const goToStripeDashboard = createAction(
  '[Common] Go To Stripe Dashboard'
);
export const goToStripeDashboardSuccess = createAction(
  '[Common] Go To Stripe Dashboard Success',
  props<{ url: string }>()
);
export const goToStripeDashboardFailure = createAction(
  '[Common] Go To Stripe Dashboard Failure',
  props<{ error: Error }>()
);
